<template>
  <div class="listItem">
    <div class="product-card">
      <div class="image">
        <z-image lazy-load fit="cover" class="cover-image" :src="data.pic" />
      </div>
      <div class="info">
        <div class="content">
          <div class="title">{{ data.title }}</div>
          <div class="time">
            <span>成交日期：</span><span>{{ data.orderTime | formatTime }}</span>
          </div>
        </div>
        <div class="price">￥{{ data.price / 100 }}</div>
      </div>
      <div class="arrow">
        <z-button
          btn-class="bottombtn"
          type="primary"
          size="small"
          @click="goto(cardType, data.status)"
        >
          {{ cardType === 'order' ? '去申请' : '去举报' }}
        </z-button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import native from '@zz-common/native-adapter'
import { Button, Image, Lazyload, Dialog } from '@zz-common/zz-ui'
import { lego } from '@zz-common/lego'

Vue.use(Lazyload)

export default {
  name: 'product-card',
  props: {
    data: Object,
    cardType: String,
    applySource: String,
    certification: Boolean,
    process: Boolean
  },
  data() {
    return {}
  },
  filters: {
    formatTime(timeStamp) {
      return timeStamp ? new Date(Number(timeStamp)).format('YYYY-MM-DD') : ''
    }
  },
  components: {
    zButton: Button,
    zImage: Image
  },
  methods: {
    order() {
      console.log('click process', process)
      if (this.data.rejectCount >= 3) {
        return Dialog({
          message: '一笔订单最多允许提交赔付信息三次，您三次申请均未通过，已无法再次申请赔付保障',
          closeOnClickOverlay: true
        })
      }
      if (this.process) {
        return Dialog({
          message: '赔付进行中，请勿重复申请',
          closeOnClickOverlay: true
        })
      }
      if (this.certification) {
        const targetUrl = `https://feentry.zhuanzhuan.com/PayMoney?clientid=PayMoneySubmit&applySource=${
          this.applySource
        }&toUid=${this.data.toUid}&orderId=${this.data.orderId}&price=${this.data.price / 100}`
        native.skipToUrl({
          targetUrl
        })
      } else {
        Dialog.confirm({
          message: '申请赔付前必须进行实人认证，以确保赔付安全，请先完成实人认证',
          confirmButtonText: '去实人认证',
          closeOnClickOverlay: true
        })
          .then(() => {
            const targetUrl =
                'zhuanzhuan://jump/core/realPersonAuth/jump?sourcecode=safecenter_page'
            native.skipToUrl({
              targetUrl
            })
          })
          .catch((_type) => {})
      }
    },
    report(status) {
      //0:正常|1:举报处理中|2:举报到上线
      if (status == 0) {
        const targetUrl = `https://feentry.zhuanzhuan.com/spam_reportreason?clientid=ReportSupplementDetial&reasonId=201&from=12&toUid=${
          this.data.toUid
        }&chooseType=3&chooseEvidence=${this.data.orderId}&moneyLoss=${this.data.price / 100}&isSupplyReport=0`
        native.skipToUrl({
          targetUrl
        })
      } else {
        Dialog({
          message: this.data.statusMsg,
          closeOnClickOverlay: true
        })
      }
    },
    goto(cardType, status) {
      lego.send({
        pagetype: 'ZZUP_PAYMONEY',
        actiontype: 'SELECT_CLICK',
        backup: {
          form: cardType || 'unknow' // report 去举报 order 去申请
        }
      })
      if (cardType === 'report') {
        this.report(status)
      }
      if (cardType === 'order') {
        this.order()
      }
    }
  },
  mounted() {}
}
</script>

<style scoped lang="less">
  @import 'index.less';
</style>
